// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../styles/typography.css";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.settings--settingsTable--d1jlz {
  width: 100%;
  border-spacing: 1px 0px;
  border-collapse: separate;
}

.settings--settingsTableInverted--Wcnti {
}

.settings--settingsTable--d1jlz td, .settings--settingsTable--d1jlz th {
  padding: 10px;
  text-align: right;
}

.settings--settingsTable--d1jlz th:first-of-type, .settings--settingsTable--d1jlz td:first-of-type {
  text-align: left;
}

.settings--settingsTable--d1jlz tbody tr:nth-child(odd) {
  background-color: var(--table-stripe--dark);
}

.settings--settingsTable--d1jlz tbody tr:nth-child(even), .settings--settingsTable--d1jlz thead tr {
  background-color: var(--table-stripe--light);
}

.settings--settingsTableInverted--Wcnti tbody tr:nth-child(odd) {
  background-color: var(--table-stripe--light);
}

.settings--settingsTableInverted--Wcnti tbody tr:nth-child(even), .settings--settingsTableInverted--Wcnti thead tr {
  background-color: var(--table-stripe--dark);
}

.settings--basalTable--iMM0H {
}

.settings--basalTable--iMM0H tbody tr:last-of-type {
  font-weight: bold;
}

.settings--basalHeaderBackground--fh4zU {
  background-image: linear-gradient(to right, var(--basal) 0, var(--basal) 14px, #d7f1fb 14px, #d7f1fb 100%);
}

.settings--automatedBasalHeaderBackground--z2KzO {
  background-image: linear-gradient(to right, var(--basal-automated) 0, var(--basal-automated) 14px, #d7f1fb 14px, #d7f1fb 100%);
}

.settings--bolusHeaderBackground--NDSNR {
  background-image: linear-gradient(to right, var(--bolus) 0, var(--bolus) 14px, #d7f1fb 14px, #d7f1fb 100%);
}

.settings--presetsHeaderBackground--ojZbH {
  background-image: linear-gradient(to right, var(--preset) 0, var(--preset) 14px, #F4F5FF 14px, #F4F5FF 100%);
}

.settings--settingsHeaderDecoration--MThzZ {
  border-bottom: 1px solid var(--table-stripe--dark);
}

.settings--settingsHeaderHeight--ptl6P {
  line-height: 1.4;
  padding: 8px 0;
}

.settings--settingsHeaderLayout--RDfgJ {
  min-width: 160px;
  padding-left: 28px;
  text-align: left;
}

.settings--settingsHeaderText--rqMmg {
}

.settings--settingsHeader--M9AM7 {
}

.settings--secondaryLeftPadding--M8isl {
  padding-left: 8px;
}

.settings--secondaryText--OUAXq {
  padding-left: 8px;
}

@media print {
  .settings--settingsTable--d1jlz {
    min-width: 250px;
    width: 100%;
    border: solid 1px #000;
    border-collapse: collapse;
    padding-bottom: 0;
  }

  .settings--settingsTable--d1jlz tbody tr,
  .settings--settingsTable--d1jlz tbody tr:nth-child(odd),
  .settings--settingsTable--d1jlz thead  {
    background-color: var(--bkgrnd-white);
    border-bottom: solid 1px #cbcbcb;
    font-weight: bold;
    color: var(--text-black);
  }

  .settings--settingsTable--d1jlz tbody tr:last-of-type, .settings--settingsTable--d1jlz thead tr:last-of-type {
    border-bottom: none;
  }

  .settings--settingsHeaderText--rqMmg {
  }

  .settings--basalTable--iMM0H {
  }

  .settings--basalTable--iMM0H tbody tr:last-of-type {
    font-weight: normal;
  }

  .settings--mainHeaderText--NHloQ {
    color: var(--text-black);
    font-weight: normal;
  }

  .settings--basalHeaderBackground--fh4zU, .settings--bolusHeaderBackground--NDSNR {
    background-image: none;
    color: var(--text-black);
    font-weight: normal;
    padding-left: 0px;
  }

  .settings--secondaryText--OUAXq {
    color: var(--text-black);
    padding-left: 8px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/settings/settings.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAIF;EAEE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;AAEA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0GAA0G;AAC5G;;AAEA;EACE,8HAA8H;AAChI;;AAEA;EACE,0GAA0G;AAC5G;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE;IAEE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;;;IAGE,qCAAqC;IACrC,gCAAgC;IAChC,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;EAEA;;EAEA;EAEA;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EAErB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IAEnB,iBAAiB;EACnB;;EAEA;IAEE,wBAAwB;IACxB,iBAAiB;EACnB;AACF","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n@import '../../styles/colors.css';\n\n.settingsTable {\n  composes: defaultSize mediumContrastText from '../../styles/typography.css';\n  width: 100%;\n  border-spacing: 1px 0px;\n  border-collapse: separate;\n}\n\n.settingsTableInverted {\n  composes: settingsTable;\n}\n\n.settingsTable td, .settingsTable th {\n  padding: 10px;\n  text-align: right;\n}\n\n.settingsTable th:first-of-type, .settingsTable td:first-of-type {\n  text-align: left;\n}\n\n.settingsTable tbody tr:nth-child(odd) {\n  background-color: var(--table-stripe--dark);\n}\n\n.settingsTable tbody tr:nth-child(even), .settingsTable thead tr {\n  background-color: var(--table-stripe--light);\n}\n\n.settingsTableInverted tbody tr:nth-child(odd) {\n  background-color: var(--table-stripe--light);\n}\n\n.settingsTableInverted tbody tr:nth-child(even), .settingsTableInverted thead tr {\n  background-color: var(--table-stripe--dark);\n}\n\n.basalTable {\n  composes: settingsTable;\n}\n\n.basalTable tbody tr:last-of-type {\n  font-weight: bold;\n}\n\n.basalHeaderBackground {\n  background-image: linear-gradient(to right, var(--basal) 0, var(--basal) 14px, #d7f1fb 14px, #d7f1fb 100%);\n}\n\n.automatedBasalHeaderBackground {\n  background-image: linear-gradient(to right, var(--basal-automated) 0, var(--basal-automated) 14px, #d7f1fb 14px, #d7f1fb 100%);\n}\n\n.bolusHeaderBackground {\n  background-image: linear-gradient(to right, var(--bolus) 0, var(--bolus) 14px, #d7f1fb 14px, #d7f1fb 100%);\n}\n\n.presetsHeaderBackground {\n  background-image: linear-gradient(to right, var(--preset) 0, var(--preset) 14px, #F4F5FF 14px, #F4F5FF 100%);\n}\n\n.settingsHeaderDecoration {\n  border-bottom: 1px solid var(--table-stripe--dark);\n}\n\n.settingsHeaderHeight {\n  line-height: 1.4;\n  padding: 8px 0;\n}\n\n.settingsHeaderLayout {\n  min-width: 160px;\n  padding-left: 28px;\n  text-align: left;\n}\n\n.settingsHeaderText {\n  composes: defaultSize mediumContrastText boldText from '../../styles/typography.css';\n}\n\n.settingsHeader {\n  composes: settingsHeaderDecoration settingsHeaderHeight settingsHeaderLayout settingsHeaderText;\n}\n\n.secondaryLeftPadding {\n  padding-left: 8px;\n}\n\n.secondaryText {\n  composes: lightText from '../../styles/typography.css';\n  padding-left: 8px;\n}\n\n@media print {\n  .settingsTable {\n    composes: defaultSize mediumContrastText from '../../styles/typography.css';\n    min-width: 250px;\n    width: 100%;\n    border: solid 1px #000;\n    border-collapse: collapse;\n    padding-bottom: 0;\n  }\n\n  .settingsTable tbody tr,\n  .settingsTable tbody tr:nth-child(odd),\n  .settingsTable thead  {\n    background-color: var(--bkgrnd-white);\n    border-bottom: solid 1px #cbcbcb;\n    font-weight: bold;\n    color: var(--text-black);\n  }\n\n  .settingsTable tbody tr:last-of-type, .settingsTable thead tr:last-of-type {\n    border-bottom: none;\n  }\n\n  .settingsHeaderText {\n    composes: defaultSize mediumContrastText from '../../styles/typography.css';\n  }\n\n  .basalTable {\n    composes: settingsTable;\n  }\n\n  .basalTable tbody tr:last-of-type {\n    font-weight: normal;\n  }\n\n  .mainHeaderText {\n    color: var(--text-black);\n    font-weight: normal;\n    composes: largeSize from '../../styles/typography.css';\n  }\n\n  .basalHeaderBackground, .bolusHeaderBackground {\n    background-image: none;\n    color: var(--text-black);\n    font-weight: normal;\n    composes: mainHeaderText;\n    padding-left: 0px;\n  }\n\n  .secondaryText {\n    composes: lightText largeSize from '../../styles/typography.css';\n    color: var(--text-black);\n    padding-left: 8px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsTable": `settings--settingsTable--d1jlz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]}`,
	"settingsTableInverted": `settings--settingsTableInverted--Wcnti settings--settingsTable--d1jlz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]}`,
	"basalTable": `settings--basalTable--iMM0H settings--settingsTable--d1jlz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} settings--settingsTable--d1jlz ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]}`,
	"basalHeaderBackground": `settings--basalHeaderBackground--fh4zU settings--mainHeaderText--NHloQ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`,
	"automatedBasalHeaderBackground": `settings--automatedBasalHeaderBackground--z2KzO`,
	"bolusHeaderBackground": `settings--bolusHeaderBackground--NDSNR settings--mainHeaderText--NHloQ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`,
	"presetsHeaderBackground": `settings--presetsHeaderBackground--ojZbH`,
	"settingsHeaderDecoration": `settings--settingsHeaderDecoration--MThzZ`,
	"settingsHeaderHeight": `settings--settingsHeaderHeight--ptl6P`,
	"settingsHeaderLayout": `settings--settingsHeaderLayout--RDfgJ`,
	"settingsHeaderText": `settings--settingsHeaderText--rqMmg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["boldText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]}`,
	"settingsHeader": `settings--settingsHeader--M9AM7 settings--settingsHeaderDecoration--MThzZ settings--settingsHeaderHeight--ptl6P settings--settingsHeaderLayout--RDfgJ settings--settingsHeaderText--rqMmg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["boldText"]}`,
	"secondaryLeftPadding": `settings--secondaryLeftPadding--M8isl`,
	"secondaryText": `settings--secondaryText--OUAXq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`,
	"mainHeaderText": `settings--mainHeaderText--NHloQ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`
};
export default ___CSS_LOADER_EXPORT___;
